class NamingHelper {
}
NamingHelper.home = "Home";
NamingHelper.reports = "Reports";
NamingHelper.officeOverview = "Office Overview";
NamingHelper.officeActiveListings = "Active Listings";
NamingHelper.officeAgents = "Agents";
NamingHelper.officeMessageLeads = "Message Leads";
NamingHelper.agencyOverview = "Overview";
NamingHelper.products = "Product Management";
NamingHelper.productsFeaturedListings = "Featured Listings";
NamingHelper.productsSpotlightListings = "Spotlight Listings";
NamingHelper.productsFeaturedAgents = "Featured Agents";
NamingHelper.productsOrderHd = "HD Listings";
NamingHelper.settings = "Settings";
NamingHelper.settingsMyProfile = "My Profile";
NamingHelper.settingsContactUs = "Contact Us";
export default NamingHelper;
